import React from "react";
import {
  Drawer,
  Box,
  Typography,
  Divider,
  Chip,
  Stack,
  IconButton,
  Fade,
  Backdrop,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FlavorDetailDrawer = ({ open, onClose, flavor }) => {
  if (!flavor) return null;

  const { seo, dietaryTags, allergens, ingredients } = flavor;

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        BackdropProps={{
          sx: { backdropFilter: "blur(3px)" }, // 🔹 nice blur background
        }}
        PaperProps={{
          sx: {
            width: 400,
            borderTopLeftRadius: 12,
            borderBottomLeftRadius: 12,
            overflow: "hidden",
            boxShadow: 4,
          },
        }}
        transitionDuration={300} // 🔹 smooth slide timing
      >
        <Fade in={open} timeout={400}>
          <Box sx={{ p: 3 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center">
              <Typography variant="h6">Flavor Details</Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" color="text.secondary">
              SEO Metadata
            </Typography>
            <Typography sx={{ mb: 1 }}>
              <strong>Meta Title:</strong> {seo?.metaTitle || "N/A"}
              <br />
              <strong>Meta Description:</strong> {seo?.metaDescription || "N/A"}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle2" color="text.secondary">
              Dietary Tags
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
              {(dietaryTags || []).map((tag) =>
                typeof tag === "object" ? (
                  <Chip key={tag._id} label={tag.label} />
                ) : (
                  <Chip key={tag} label={tag} />
                )
              )}
            </Stack>

            <Typography variant="subtitle2" color="text.secondary">
              Allergens
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
              {(allergens || []).map((allergen) =>
                typeof allergen === "object" ? (
                  <Chip key={allergen._id} label={allergen.name} />
                ) : (
                  <Chip key={allergen} label={allergen} />
                )
              )}
            </Stack>

            <Typography variant="subtitle2" color="text.secondary">
              Ingredients
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {(ingredients || []).map((ingredient) =>
                typeof ingredient === "object" ? (
                  <Chip key={ingredient._id} label={ingredient.name} />
                ) : (
                  <Chip key={ingredient} label={ingredient} />
                )
              )}
            </Stack>
          </Box>
        </Fade>
      </Drawer>
    </>
  );
};

export default FlavorDetailDrawer;
